module.exports = __webpack_public_path__ + "static/img/logo.e41f887a.svg";